module.exports = __webpack_public_path__ + "img/wfirey.306b48f5.png";